// Libraries
import { Box, Grid, Typography } from "@mui/material";

// Components
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";
import LabeledFormInput from "@/Layouts/components/SmartAddressFormSection/LabeledFormInput";

// Constants
import { CONSENTS_MAPPING, PREFERRED_CONTACT_METHODS, SEND_TEXTS_TO, YES_NO_OPTIONS } from "../../../constants";
import { Z_INDEX_FOR_SELECTOR_LIST_IN_POPUP } from "@/Constants/misc";

//  Types
import { TConsent, TSelectValue, TYesNoOption } from "../../../types";

// Contexts
import { useLeadsContext } from "@/DataPages/context/crm/LeadsContext";
import { TConsentOption } from "@/DataPages/context/crm/interfaces";

export function CustomerCommConsentSection(props: Readonly<{ sx?: React.CSSProperties; className?: string; selectorListZIndex?: number }>) {
	const { sx, className, selectorListZIndex = Z_INDEX_FOR_SELECTOR_LIST_IN_POPUP } = props ?? {};
	const commonPopperProps = { sx: { zIndex: `${selectorListZIndex}!important` } };

	const { isSavingLead, getContextValue, onChangeContext, getContextError } = useLeadsContext();

	/* Handlers */
	function handleConsentChange(option: TYesNoOption, consentType: keyof TConsent) {
		onChangeContext("customer", consentType, option.value);
	}

	function handleOptionChange(option: TSelectValue, key: "preferredContactMethod" | "sendTextTo") {
		onChangeContext("customer", key, option.value);
	}

	return (
		<Box className={className} sx={sx}>
			<Typography className="!font-montserrat !font-[500] !text-[16px] !text-gray-text !mb-3">Communication and Consent</Typography>
			<Box className="w-full flex flex-col gap-[12px] mt-[6px]">
				<Grid container spacing={2}>
					<Grid item xs={12} sm={4}>
						<LabeledFormInput
							label="Preferred Contact Method"
							formInput={
								<SmartSelector
									selectBy={"value"}
									showBy={"text"}
									options={PREFERRED_CONTACT_METHODS}
									selected={getContextValue("customer", "preferredContactMethod")}
									inputProps={{
										placeholder: "Preferred Contact Method",
									}}
									onChangeAction={(value) =>
										handleOptionChange(value as unknown as TSelectValue, "preferredContactMethod")
									}
									popperProps={commonPopperProps}
									disabled={isSavingLead}
								/>
							}
						/>
					</Grid>

					<Grid item xs={12} sm={4}>
						<LabeledFormInput
							label="Send Texts To"
							formInput={
								<SmartSelector
									selectBy={"value"}
									showBy={"text"}
									options={SEND_TEXTS_TO}
									selected={getContextValue("customer", "sendTextTo")}
									inputProps={{
										placeholder: "Send Texts To",
									}}
									onChangeAction={(value) => handleOptionChange(value as unknown as TSelectValue, "sendTextTo")}
									popperProps={commonPopperProps}
									disabled={isSavingLead}
								/>
							}
						/>
					</Grid>
				</Grid>

				<Grid container spacing={2}>
					{Object.entries(CONSENTS_MAPPING).map(([key, { label }]) => (
						<Grid key={key} item xs={12} sm={2}>
							<LabeledFormInput
								label={label}
								formInput={
									<SmartSelector
										selectBy={"value"}
										showBy={"name"}
										options={[...YES_NO_OPTIONS]}
										selected={getContextValue("customer", key as keyof typeof CONSENTS_MAPPING)}
										inputProps={{
											placeholder: "Y/N",
										}}
										onChangeAction={(value) =>
											handleConsentChange(
												value as unknown as { name: string; value: TConsentOption },
												key as keyof TConsent
											)
										}
										popperProps={commonPopperProps}
										disabled={isSavingLead}
										error={getContextError("customer", key as keyof typeof CONSENTS_MAPPING)}
									/>
								}
							/>
						</Grid>
					))}
				</Grid>
			</Box>
		</Box>
	);
}

export default CustomerCommConsentSection;
